import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    value: null,
};

export const gmbDashboardSlice = createSlice({
    name: 'gmbDashboard',
    initialState,
    reducers: {
        update: (state,action) => {
            state.value = action.payload;
        }
    }
});

export const {update} = gmbDashboardSlice.actions;
export default gmbDashboardSlice.reducer;

